import { Stack } from '@mui/joy'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router-dom'
import { ActionButtons as AppealActionButtons } from '~/entities/common/Balance/Appeal'
import { ActionButtons as BalanceHistoryActionButtons } from '~/entities/common/Balance/BalanceHistory'
import { Appeal, BalanceHistory } from '~/shared/api'
import { Container, PageTitle } from '~/shared/ui/Layout'

export function Header() {
  const { t } = useTranslation()
  const { pathname } = useLocation()

  const isBalanceHistoriesPage = useMemo(
    () => !!matchPath('/balance/balance-histories', pathname),
    [pathname],
  )
  const isAppealsPage = useMemo(
    () => !!matchPath('/balance/appeals', pathname),
    [pathname],
  )

  return (
    <Container isHeader>
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <PageTitle>{t('balances')}</PageTitle>

        {isBalanceHistoriesPage && (
          <BalanceHistoryActionButtons
            parentPath='balance-histories'
            exportFn={BalanceHistory.exportBalanceHistory}
            canMassImport
          />
        )}
        {isAppealsPage && (
          <AppealActionButtons exportFn={Appeal.exportAppeal} />
        )}
      </Stack>
    </Container>
  )
}
